export default {
  REQUIRED: 'Please fill in!',
  EMAIL: {
    LENGTH: 'Max. 64 chars allowed',
    INVALID: 'E-Mail invalid',
  },
  PASSWORD: {
    INVALID: 'At least 8 chars, at least one capital letter, at least one number, at least one special character',
    MISMATCH: 'The passwords must match',
  },
  IBAN: {
    INVALID: 'Invalid German IBAN (DE + 22 characters: 2 check digits, 8-digit bank code, 10-digit account number)',
  },
  LANR: {
    INVALID: 'Invalid LANR (9-digit number sequence)',
  },
  BSNR: {
    INVALID: 'Invalid BSNR (9-digit number sequence)',
  },
};
